import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GraphAPITaskIdResult  {
    _originalTypeClassName = "ekylikeio.BO.GraphAPITaskIdResult";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GraphAPITaskIdResult.translate = translateService;
}
this.Success = false;
this.TaskId = null;
this.GraphAPITaskIdResultKey = null;
this._key = this.GraphAPITaskIdResultKey = 0; 
}

static translate: TranslateService;
_key: any;
Success:any;
TaskId:any;
private _GraphAPITaskIdResultKey:any;
get GraphAPITaskIdResultKey(): any {
    return this._GraphAPITaskIdResultKey;
  }
set GraphAPITaskIdResultKey(value: any) {
    this._GraphAPITaskIdResultKey = value;
    this._key = value;
  }

static CreateFrom(success: any,taskId: any): any{let result = new Domain.GraphAPITaskIdResult();
result.Success = success;
result.TaskId = taskId;
return result;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GraphAPITaskIdResultKey == null || $this.GraphAPITaskIdResultKey == 0;
            }


}